// 바텀 시트 그래버 드래그 — 손가락을 따라 시트가 내려오고, 충분히 내리면
// 그 자리에서 마저 미끄러져 닫힌다. 덜 내렸으면 제자리로 튕겨 돌아온다.
// (처음엔 '놓는 순간 60px 넘었으면 닫기'만 있었는데, 시트가 손을 안 따라와
// 앱답지 않았다 — Bishop 제보. 표준 모바일 시트 패턴으로 맞춘다.)
//
// 그래버에는 touch-action:none 이 걸려 있어(각 CSS) 브라우저 제스처(스크롤·
// 당겨서 새로고침)와 싸우지 않는다. React 의 터치 리스너는 passive 라
// preventDefault 는 못 쓰지만, 여기선 좌표만 읽고 transform 만 쓴다.
import { useRef } from "react";

/** 이만큼 내렸으면 닫는다 — 시트 높이의 비율이 아니라 고정 px (한 손 엄지 기준) */
const CLOSE_AT = 110;

/**
 * 그래버에 얹을 터치 핸들러 한 벌.
 * @param selector 시트 루트 셀렉터 — 그래버에서 closest 로 찾는다 (.mk-sheet 등)
 * @param close    닫기 — 상태를 내리는 함수 (여러 번 불려도 안전해야 한다)
 */
export function useSheetDrag(selector: string, close: () => void) {
  const st = useRef<{ y: number; el: HTMLElement | null; moved: boolean }>(
    { y: 0, el: null, moved: false });

  return {
    onTouchStart: (e: React.TouchEvent) => {
      const el = (e.currentTarget as HTMLElement).closest(selector) as HTMLElement | null;
      st.current = { y: e.touches[0].clientY, el, moved: false };
      if (el) el.style.transition = "none";   // 따라오는 동안엔 보간 없이 1:1
    },
    onTouchMove: (e: React.TouchEvent) => {
      const s = st.current;
      if (!s.el) return;
      const dy = Math.max(0, e.touches[0].clientY - s.y);   // 위로는 안 끌린다
      if (dy > 4) s.moved = true;
      s.el.style.transform = `translateY(${dy}px)`;
    },
    onTouchEnd: (e: React.TouchEvent) => {
      const s = st.current;
      const el = s.el;
      st.current = { y: 0, el: null, moved: false };
      if (!el) return;
      const dy = Math.max(0, e.changedTouches[0].clientY - s.y);
      if (dy > CLOSE_AT) {
        // 인라인을 걷고 즉시 닫는다 — 닫힘 클래스의 목표(translateY 103%)로
        // 스타일시트 transition 이 '손을 뗀 자리(dy)'에서부터 이어서 보간한다.
        // (처음엔 setTimeout 으로 직접 밀었는데, 타이머는 숨김 탭에서 1초로
        // 스로틀되고 상태 정리가 늦어 두 경로가 어긋났다 — 타이머 없이 간다)
        el.style.transition = "";
        el.style.transform = "";
        close();
      } else {
        // 제자리로 — 인라인을 걷으면 스타일시트의 transition 이 받아 스르르 복귀
        el.style.transition = "";
        el.style.transform = "";
        if (!s.moved) close();   // 이동 없는 탭은 그대로 닫기
      }
    },
  };
}
